import {CareJourneyDetailsResponse, CareJourneyLogType} from '@/api/dto/care-journey';
import TaskLog from '@/components/pages/tasks/task_edit/log/TaskLog';
import {EmptyLogs, Wrapper} from '@/components/pages/tasks/task_edit/log/TaskEditLog.styles';

type Props = {
  careJourneyDetails: CareJourneyDetailsResponse;
  setCurrentTab(index: number, stepName: string): void;
}

export default function TaskEditLog({ careJourneyDetails, setCurrentTab }: Props) {
  const logs = careJourneyDetails.logs
    .filter((careJourneyLog) => careJourneyLog.logType !== CareJourneyLogType.UNKNOWN);

  if (!logs.length) {
    return <EmptyLogs>No logs found</EmptyLogs>;
  }

  return (
    <Wrapper>
      {logs
        .sort((a, b) => new Date(b.eventDatetime).getTime() - new Date(a.eventDatetime).getTime())
        .map((careJourneyLog) => (
          <TaskLog key={careJourneyLog.id} careJourneyLog={careJourneyLog} setCurrentTab={setCurrentTab} />
        ))}
    </Wrapper>
  );
}
